// src/components/Navbar/MobileMenu.js
import React from "react";
import { collectionBanners } from "../../data/products";
import "./MobileMenu.css";

export default function MobileMenu({ open, onClose }) {
  return (
    <>
      <div className={`mobile-overlay ${open ? "mobile-overlay--open" : ""}`} onClick={onClose} />
      <aside className={`mobile-menu ${open ? "mobile-menu--open" : ""}`}>
        <div className="mobile-menu__header">
          <div className="mobile-menu__logo">
            <svg viewBox="0 0 48 52" fill="none" width="40" height="44">
              <ellipse cx="24" cy="20" rx="15" ry="16" fill="none" stroke="white" strokeWidth="2.5"/>
              <circle cx="17" cy="15" r="3.5" fill="white"/>
              <circle cx="31" cy="15" r="3.5" fill="white"/>
              <path d="M17 25 Q24 31 31 25" stroke="white" strokeWidth="2" fill="none"/>
              <path d="M9 36 L24 36 L39 36 L39 52 L30 46 L24 52 L18 46 L9 52 Z" fill="white"/>
            </svg>
            <div>
              <div style={{ color: "white", fontWeight: 700, fontSize: 14, lineHeight: 1.1 }}>The Souled Store</div>
              <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 9, letterSpacing: 3 }}>MEMBER</div>
            </div>
          </div>
          <button className="mobile-menu__close" onClick={onClose}>✕</button>
        </div>

        <button className="mobile-menu__login">Log In / Register</button>

        <div className="mobile-menu__cashback">
          <span>Earn 10% Cashback on Every App Order</span>
          <div className="mobile-menu__store-badges">
            <span className="mobile-menu__store-badge mobile-menu__store-badge--play">▶</span>
            <span className="mobile-menu__store-badge mobile-menu__store-badge--apple">A</span>
          </div>
        </div>

        <nav className="mobile-menu__nav">
          {["MEN", "WOMEN", "SNEAKERS"].map(item => (
            <button key={item} className={`mobile-menu__nav-item ${item === "MEN" ? "mobile-menu__nav-item--active" : ""}`}>
              {item}
            </button>
          ))}
        </nav>

        <div className="mobile-menu__collections">
          <div className="mobile-menu__grid">
            {collectionBanners.slice(0, 5).map(c => (
              <div key={c.id} className="mobile-menu__col-item">
                <img src={c.img} alt={c.label} />
                <span>{c.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mobile-menu__section-title">Summer '26</div>
        <div className="mobile-menu__collections">
          <div className="mobile-menu__grid">
            {collectionBanners.slice(5).map(c => (
              <div key={c.id} className="mobile-menu__col-item">
                <img src={c.img} alt={c.label} />
                <span>{c.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mobile-menu__shop-all">
          <span>Shop All</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </div>
      </aside>
    </>
  );
}
